/*
 * Header transparent jusqu'à la fin du diaporama du haut de page.
 *
 * Dès que la page défile, le thème (theme.min.js) fixe le header en haut de l'écran et lui retire
 * la classe header--transparent, à chaque image du défilement. Tant que le bas du diaporama placé
 * sous le header n'est pas remonté jusqu'au bas du header transparent, on remet cette classe aussitôt
 * (le MutationObserver passe avant l'affichage), puis on laisse le header redevenir plein.
 * Chargé par snippets/frame--header.liquid sur les pages au header transparent.
 */
(() => {
  const header = document.querySelector('#header[data-transparent-header="true"]');
  if (!header) return;

  // Diaporama qui commence sous le header transparent, en haut de page
  const slideshow = Array.from(document.querySelectorAll('.slideshow')).find(
    (element) => element.getBoundingClientRect().top + window.scrollY < header.offsetHeight
  );
  if (!slideshow) return;

  // Le logo de la version transparente n'a pas forcément la hauteur du logo normal, et le thème calcule la
  // hauteur du diaporama avec celle du header : on ne mesure le header et le bas du diaporama (position dans
  // la page) que lorsque le header est transparent, sinon la limite bougerait à chaque bascule et la ferait
  // rebasculer.
  let transparentHeaderHeight = header.offsetHeight;
  let slideshowBottom = slideshow.getBoundingClientRect().bottom + window.scrollY;
  let overSlideshow = true;

  // Réapplique l'état calculé, sans mesure : appelée aussi quand le thème change les classes du header
  const apply = () => {
    if (!document.documentElement.classList.contains('header-stuck')) return;
    header.classList.toggle('header--transparent', overSlideshow);
  };

  const update = () => {
    if (header.classList.contains('header--transparent')) {
      transparentHeaderHeight = header.offsetHeight;
      slideshowBottom = slideshow.getBoundingClientRect().bottom + window.scrollY;
    }
    overSlideshow = slideshowBottom - window.scrollY > transparentHeaderHeight;
    apply();
  };

  new MutationObserver(apply).observe(header, { attributes: true, attributeFilter: ['class'] });
  window.addEventListener('scroll', update, { passive: true });
  window.addEventListener('resize', update);
  update();
})();
